import { useEffect, useState } from "react";
import AutocompleteField from "./AutocompleteField";
import { useDispatchApp } from "../../lib/redux";
import { startGetAdsUsers } from "../../actions/user";

const SelectUser = ({
  label,
  name,
  control,
  multiple,
  fullWidth = true,
  errors,
  sx = {},
  mode = "form",
  triggerVariant,
  onGetDisplayText = () => {},
  showEmptyOption = false,
  emptyOptionText = "",
  startIcon = null,
  sxText = {},
}) => {
  const [users, setUsers] = useState([]);

  const dispatch = useDispatchApp();

  const onGetUsers = async () => {
    const response = await dispatch(startGetAdsUsers());
    if (!response) return;
    setUsers(response);
  };

  useEffect(() => {
    onGetUsers();
    // eslint-disable-next-line
  }, []);

  const options = Object.keys(users).map((userID) => ({
    label: users?.[userID]?.name || "",
    value: userID,
  }));

  return (
    <AutocompleteField
      fullWidth={fullWidth}
      label={label}
      name={name}
      control={control}
      multiple={multiple}
      options={options}
      errors={errors}
      sx={sx}
      mode={mode}
      triggerVariant={triggerVariant}
      onGetDisplayText={onGetDisplayText}
      showEmptyOption={showEmptyOption}
      emptyOptionText={emptyOptionText}
      startIcon={startIcon}
      sxText={sxText}
    />
  );
};

export default SelectUser;
